import React from 'react'
import { Field, Formik } from 'formik'
import { Button, Form, FormGroup, Label } from 'reactstrap'
import { customInputForm } from 'ui/common'
import { useDispatch } from 'react-redux'
import { createMapConfigs, getMapConfigs } from 'features/dashboard/Map.actionTypes'

const SaveMapConfig = ({ toggle, uuid }) => {
    const dispatch = useDispatch()

    const handleSubmit = (values) => {
        const { title } = values
        const data = { title: title ? title : `Map configuration ${new Date().toLocaleString()}` }
        dispatch(createMapConfigs({ uuid, data })).then((res) => {
            if (!res.error) {
                dispatch(getMapConfigs({ uuid }))
                toggle()
            }
        })
    }

    return (
        <>
            <div className="mb-4">
                <div
                    style={{ marginBottom: '24px' }}
                    className="d-flex w-100 justify-content-end align-items-start"
                >
                    <img
                        src="/svgs/close-icon/x-dark-default.svg"
                        alt="obstacle-icon"
                        width="24px"
                        height="24px"
                        style={{ cursor: 'pointer' }}
                        onClick={toggle}
                    />
                </div>
                <h5>Save as new map configuration</h5>
            </div>
            <Formik initialValues={{ title: '' }} onSubmit={handleSubmit}>
                {({ values, handleSubmit }) => (
                    <Form className="form-wrapper" onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label className="modals-labels ">Name</Label>
                            <Field
                                className="modals-inputs"
                                type="text"
                                name="title"
                                placeholder="Name"
                                component={customInputForm}
                                value={values.title || ''}
                            />
                        </FormGroup>
                        <div className="d-flex justify-content-end mt-4">
                            <Button
                                color="none"
                                onClick={toggle}
                                className="cancel-btn-modal modals-new-btns mr-2"
                            >
                                Cancel
                            </Button>

                            <Button type="submit" className="save-btn-modal modals-new-btns">
                                Save
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default SaveMapConfig
